module.exports = "/assets/site/images/custom-competition-header-image_2.png?1525782b5a4e7f4e4b293f76f6fc8a22";